import React, { useState } from "react"
import { Button, Tabs } from "antd"
import { useTranslation } from "react-i18next"
import PageCustomHeader from "Components/PageCustomHeader"
import AccountStatements from "./accountStatement"
import FundingHistory from "./fundingHistory"
import WalletIcon from "Components/icons/walletIcon"
import WalletFundingModal from "Components/modals/walletFunding.modal"
import WalletWithdrawalModal from "Components/modals/walletWithdrawal.modal"
import { useLoggedInEmployee } from "Shared/hooks/employee.hooks"
import { RolesEnum } from "@finway-group/shared/lib/models"
import { useIsOutgoingWireTransferEnabled } from "Shared/hooks/featureFlags.hooks"

const { TabPane } = Tabs

enum WalletActiveTab {
    ACCOUNT_STATEMENTS = "ACCOUNT_STATEMENTS",
    FUNDING_HISTORY = "FUNDING_HISTORY",
}

const WalletDetailsContainer = () => {
    const { t } = useTranslation()
    const [activeTab, setActiveTab] = useState<any>(WalletActiveTab.ACCOUNT_STATEMENTS)
    const [isWalletFundingModalVisible, setIsWalletFundingModalVisible] = useState(false)
    const [isWalletWithdrawalModalVisible, setIsWalletWithdrawalModalVisible] = useState(false)
    const loggedInUser = useLoggedInEmployee()
    const isOutgoingWireTransferEnabled = useIsOutgoingWireTransferEnabled()

    return (
        <div>
            <PageCustomHeader
                title={
                    <div className="flex">
                        <h1 className="-mb-2">{t("label:wallet.wallet_details")}</h1>
                    </div>
                }
                actionButtons={
                    <>
                        {loggedInUser.activeCompanyProfile?.weavrData?.isPasswordCreated &&
                            loggedInUser.activeCompanyProfile?.role === RolesEnum.ADMIN &&
                            isOutgoingWireTransferEnabled && (
                                <Button onClick={() => setIsWalletWithdrawalModalVisible(true)}>
                                    <WalletIcon />
                                    <span>{t("action:wallet.withdrawal")}</span>
                                </Button>
                            )}
                        <Button onClick={() => setIsWalletFundingModalVisible(true)} type="primary">
                            <WalletIcon className="mb-2" />
                            <span className="mt-0">{t("action:wallet.funding")}</span>
                        </Button>
                    </>
                }
            />

            <Tabs defaultActiveKey={WalletActiveTab.ACCOUNT_STATEMENTS} activeKey={activeTab} className="pb-10" onTabClick={(key) => setActiveTab(key)}>
                <TabPane tab={t("creditCard:label.account_statement")} key={WalletActiveTab.ACCOUNT_STATEMENTS}>
                    <AccountStatements />
                </TabPane>

                <TabPane tab={t("creditCard:label.funding_history")} key={WalletActiveTab.FUNDING_HISTORY}>
                    <FundingHistory />
                </TabPane>
            </Tabs>
            <WalletFundingModal isVisible={isWalletFundingModalVisible} handleCancel={() => setIsWalletFundingModalVisible(false)} />
            {isOutgoingWireTransferEnabled && <WalletWithdrawalModal isVisible={isWalletWithdrawalModalVisible} handleCancel={() => setIsWalletWithdrawalModalVisible(false)} />}
        </div>
    )
}

export default WalletDetailsContainer
